module.exports = __webpack_public_path__ + "static/Lamentum2-86c20c8697ab53b4063982e3c6574058.webp";